import React from "react";
import MasterDataTab from "../../../../id/common/MasterDataTab";
import { EMPTY_GUID, CUSTOMER_ID_TYPE, CONTACT_MEMBER_TYPE, GRID_KEYS } from '../constants';
import SelectCustomerPlaceholder from './SelectCustomerPlaceholder';

// Reuses the generic ID-relationship-links component already used by
// customerDataEntry/warehouseDataEntry/consigneeDataEntry/carrierDataEntry - matches
// legacy ARD0009's Contact tab (grdBottomContact), which itself supports add/delete via
// its navigator, not just browsing.

function ContactTab(props) {
    const hasCustomer = !!props.customerId && props.customerId !== EMPTY_GUID;

    if (!hasCustomer) {
        return <SelectCustomerPlaceholder content="contacts" />;
    }

    return (
        <MasterDataTab
            RIDMaster={props.customerId}
            IDType={CUSTOMER_ID_TYPE}
            IDMemeberType={CONTACT_MEMBER_TYPE}
            TabName="Contact"
            gridKey={GRID_KEYS.Contact}
        />
    );
}

export default ContactTab;
